module.exports = (fox, _) => ({
	onEmptyBalance() {
		this.treatError({
			id: _.ERROR_EMPTY_BALANCE
		});

		return this.leaveLiveshow();
	},

	sendPaidShowRequest(params) {
		const {
			requestRateId: rateId,
			requestPrice: price,
			requestType: type,
			btn,
			...rest
		} = params;

		const pcb = this.rwom1('#paidShowConfirmBody');

		this.toggleBtnLoader(btn);

		return this.checkPayer({ rateId, ...rest }, $(btn)).then((token) => {
			this._log(`got token`);
			if (this.isDisconnected()) {
				const error = {
					msg: 'liveshow disconnected',
					params: { answer: { code: 'model.disconnected' } }
				};

				if (this.isEmbedded()) {
					throw error;
				} else {
					return this.dispatchEvent('paid_request_error', error);
				}
			}

			this.los.setItem(token, this.getChatUserId());

			const msg = {
				text: this.getPaidShowRequestToken(),
				paidShowType: type,
				trustedHash: token,
				type: 3
			};

			if (price)
				msg.paidShowPrice = price;

			this._log('sending private request');
			this.sendMessageToModel(msg);

			pcb.setTemplateOptions('state', 3).render();
			this.isRequester = token;

			return [
				true,
				new fox.Promise(resolve => setTimeout(() => {
					pcb.setTemplateOptions({});
					this.switchEmbeddedWidget('sidebarMain');

					resolve(true);
				}, 3000))
			];
		}).catch((resp) => {
			if (resp.params) {
				switch(resp.params.answer.code) {
					case 12:
						const { username, email, token, ...rest } = params;

						this.wait('@root #permissionManager', 'permissions_update').then(() => {
							setTimeout(() => this.toggleBtnLoader(fox.dom.selectFirst(`#${rest.btn.id}`, pcb.element)), 100);
						});

						return this.rwom1('#authorizePopup').show().then(result => {
							if (result !== false) {
								this.controller.release();
								return this.getParent().checkLiveShows().then(() => {
									const promise = this.wait('#paidShowConfirmBody', 'addedToDom');
									this.showPaidConfirm();

									return promise;
								}).then(() => {
									rest.btn = fox.dom.selectFirst(`#${rest.btn.id}`, pcb.fragment); /* avoid select from element */
								}).then(() => this.sendPaidShowRequest(rest))
							}

							this.toggleBtnLoader(fox.dom.selectFirst(`#${rest.btn.id}`, pcb.element));

							return [result];
						});
					default:
						pcb.setTemplateOptions({
							state: 3,
							errorCode: resp.params.answer.code
						}).render();
				}

				return [false];
			}

			throw resp;
		});
	},

	checkPayer(params, $btn) {
		const api = this.getApi('openSession', {
			method: 'liveshow.checkPayer',
			httpMethod: 'post'
		});
		const cbpopup = this.rwom1('#cbPaymentPopup');
		const sendingPromise = api.psend({
			id: this.connectParams.sessionId,
			...params
		}).then(({ params: { answer: { response }}}) => response);

		cbpopup.show(sendingPromise.then(({ redirect: url }) => {
			return { url };
		}))

		return sendingPromise.then((answer) => {
			if ($btn)
				$btn.toggleClass(_.DOM_CLASS_SPIN);

			if ($btn.is('button'))
				$btn.prop('disabled', false);

			if (answer === true) {
				cbpopup.hide();

				return true;
			}

			return this.wait('@root #socket', 'inboxSocketEventLiveshow:billing:payInfoSuccess');
		}).then(resp => {
			if (cbpopup.isOpen())
				cbpopup.hide();

			this.wait('@root #socket', 'inboxSocketEventLiveshow:billing:emptyBalance')
				.then((...args) => this.onEmptyBalance(...args));

			const token = fox.objectGet(resp, 'params.answer.token');

			if (token)
				return this.autoLoginService.shouldAuthorize(token)
					.then(result => {
						if (result === true) {
							this._log('shouldAuthorize success');
							return this.connectToChat()
								.then((roomAlias) => this._log(`connected to the room ${roomAlias}`))
								.then(() => {
									this._log('tiny delay after connect to chat');
									return new fox.Promise(resolve => setTimeout(resolve, 1000));
								}).then(() => token);
						}
						
						throw {
							params: { answer: { code: 'auth.error' } }
						}
					});

			const { token: trustedHash } = this.autoLoginService.injectToken({}, new Date().getTime().toString());

			return trustedHash;
		}).catch(error => {
			cbpopup.hide();

			throw error;
		});
	},

	giftPaid(gifts) {
		function sendGift(alias) {
			alias = alias.split(':');

			var m = {
				type: 1,
				gift: alias[0],
				price: alias[1]
			};

			var msg = {
				text: 'gift',
				name: this.getMemberInfo('login'),
				dataset: m,
				own: this.getMemberInfo('id')
			};

			this.setChatMessage(msg)
				.rwom1('@root #uchatctrl').sendMessage(msg, this.getRoomAlias());
		}

		var btn = this.dom1('#toggle-gift-box');

		if (gifts.length) {
			this.toggleGiftBox(btn, 'giftPaidSuccess');
		}

		if (this.rwom1('.Widget #tabChat').isEmbedded()) {
			fox.each(gifts, sendGift, this);
		} else {
			this.wait('.Widget #tabChat', 'addedToDom').then(() => {
				fox.each(gifts, sendGift, this);
			});
		}
	},

	onTipSuccessfully() {
		const translator = this.getParent();
		const $c = $(this.element[0]);
		const m = {
			type: 2,
			price: this.amount
		};

		const msg = {
			text: 'tip',
			own: translator.getMemberInfo('id'),
			name: translator.getMemberInfo('login'),
			dataset: m
		};

		translator.setChatMessage(msg)
			.rwom1('@root #uchatctrl').sendMessage(msg, translator.getRoomAlias());

		translator._onPaidSuccessfully();
	}
});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/mixins/translatorBillingMethods.es.js